import { useEffect, useState } from "react";

// Mirrors a value after a quiet period, but starts at the value it was handed so the
// first render already has it. A burst of filter clicks settles into one update without
// the initial one arriving late.
//
// `syncKey` names the context the value belongs to — a worklist, say. Moving to a new
// context is not a burst, so the value settles at once and the request that goes with it
// is never built from the previous context's value.
const useDebouncedValue = (value, delay, syncKey) => {
  const [settled, setSettled] = useState(value);
  const [lastSyncKey, setLastSyncKey] = useState(syncKey);

  if (syncKey !== lastSyncKey) {
    setLastSyncKey(syncKey);

    if (value !== settled) setSettled(value);
  }

  useEffect(() => {
    if (value === settled) return undefined;

    const timer = setTimeout(() => setSettled(value), delay);

    return () => clearTimeout(timer);
  }, [value, settled, delay]);

  return settled;
};

export default useDebouncedValue;
